import script from "./QuickKillPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickKillPanel.vue?vue&type=script&setup=true&lang=ts"

import "./QuickKillPanel.vue?vue&type=style&index=0&id=28ee228e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ee228e"]])

export default __exports__